import { action, computed, makeObservable, observable } from 'mobx'

import { DTO } from '..'

export class FavoriteChapter extends DTO {
  curriculumId: number
  bigChapterName: string
  problemIdList: number[]
  semesterId: res.FavoriteChapter['semesterId']
  subjectId: res.FavoriteChapter['subjectId']

  constructor(data: res.FavoriteChapter) {
    super()
    this.curriculumId = data.curriculumId
    this.bigChapterName = data.bigChapterName
    this.problemIdList = data.problemIdList
    this.semesterId = data.semesterId
    this.subjectId = data.subjectId

    makeObservable(this, {
      curriculumId: observable,
      bigChapterName: observable,
      problemIdList: observable,
      semesterId: observable,
      subjectId: observable,
      semesterSubjectId: computed,
      deleteProblemId: action,
    })
  }

  get semesterSubjectId() {
    return this.semesterId ?? this.subjectId
  }

  deleteProblemId = (problemId: number) => {
    this.problemIdList = this.problemIdList.filter((id) => id !== problemId)
  }
}
